module.exports = __webpack_public_path__ + "static/media/bed_corona_myway.872fa4df.svg";